// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"59":"b2f7b7c3","142":"3dd24a66","193":"b2f7b7c3","215":"15270d29","371":"94734480","828":"6bceae11","996":"0fe7390a"}[chunkId] + ".chunk.css";
};